import urlTemplate from 'url-template';
export function parse(template) {
  const parsedTemplate = urlTemplate.parse(template);
  return {
    expand: context => parsedTemplate.expand(context)
  };
}